'use strict';
const Work = require('process/domain/entity/work/index');

module.exports = Work.extend({
    getName: function() {
        return this.getTarget().get('name');
    },
});



// WEBPACK FOOTER //
// ./balus/domain/entity/work/diagram.js